import React from 'react'; 
import InteractiveCard from '../components/InteractiveCard';
import LincolnMKTCard from '../components/LincolnMKTCard';
import CadillacEscaladeCard from '../components/CadillacEscaladeCard';
import MercedesSprinterCard from '../components/MercedesSprinterCard';
import Header from '../components/Header';
import jetblackBg from '../assets/images/jetblack-bg.png';

const FleetPage = ({ onNavigate }) => {
  return (
    <div style={styles.pageContainer}>
      {/* Barra de navegación */}
      <Header />

      {/* Sección Hero */}
      <div style={styles.heroSection}>
        <div style={styles.heroOverlay}></div>
        <div style={styles.heroContent}>
          <h1 style={styles.heroTitle}>Our Luxury Fleet</h1>
          <p style={styles.heroSubtitle}>Experience unmatched elegance and performance</p>
        </div>
      </div>

      {/* Sección de vehículos */}
      <section style={styles.section}>
        <div style={styles.cardsContainer}>
          <InteractiveCard />
          <LincolnMKTCard />
          <CadillacEscaladeCard />
          <MercedesSprinterCard />
        </div>
      </section>

      {/* CSS incluido en el archivo */}
      <style>
        {`
          .hoverable-section:hover {
            border-color: gold;
            box-shadow: 0 4px 20px rgba(255, 215, 0, 0.5);
          }
        `}
      </style>
    </div>
  );
};

const styles = {
  pageContainer: {
    backgroundColor: '#fff', // Fondo blanco
    color: '#000',           // Texto en negro para contraste
    fontFamily: 'Arial, sans-serif',
    minHeight: '100vh',
    overflowX: 'hidden',
    position: 'relative',
  },
  heroSection: {
    position: 'relative',
    width: '100%',
    height: '350px', // Altura de la sección hero
    backgroundImage: `url(${jetblackBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '30px', // Alinea el contenido a la izquierda
    color: '#fff',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.6)',
  },
  heroOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: 0,
  },
  heroContent: {
    position: 'relative',
    zIndex: 1,
    textAlign: 'left',
    maxWidth: '80%',
  },
  heroTitle: {
    fontSize: '3rem',
    margin: 0,
  },
  heroSubtitle: {
    fontSize: '1.5rem',
    margin: '15px 0 0',
  },
  section: {
    margin: '40px auto',
    padding: '40px 25px',
    background: '#fff',
    borderRadius: '8px',
    border: '1px solid rgba(0, 0, 0, 0.2)',
    boxShadow: '0 2px 15px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease',
    maxWidth: '1100px',
  },
  cardsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
    alignItems: 'center',
    marginTop: '40px',
    padding: '20px',
  },
};

export default FleetPage;
